<IziGrid class="settings-challenge-container">
  <IziCol class="list-question">
    <ListQuestions v-model:questions="settingsChallenge.questions" />
  </IziCol>
  <IziCol class="setting-header">
    <IziGrid>
      <IziCol xl="9" lg="9" md="9" col="9" class="input-challenge-name">
        <IziGrid>
          <IziCol xl="3" lg="3" md="3" col="2" class="col-title-challenge"><span>Title</span></IziCol>
          <IziCol xl="9" lg="9" md="9" col="10">
            <IziInput icon="pi-search" iconPos="left" label="Enter Challenge Name"
              v-model:value="settingsChallenge.challengeName" />
          </IziCol>
          <IziCol xl="3" lg="3" md="3" col="2" class="col-add-description">
            <span>Description: </span>
          </IziCol>
          <IziCol xl="9" lg="9" md="9" col="10">
            <Textarea v-model="settingsChallenge.challengeDescription" rows="3" cols="30" autoResize="false"
              style="overflow-y: scroll; height: 64px" />
            </IziCol>
        </IziGrid>
      </IziCol>
      <IziCol  xl="3" lg="3" md="3" col="3">
        <UploadImage v-model:imageUrl="settingsChallenge.imageChallenge" imageType="challenge" />
      </IziCol>
    </IziGrid>
  </IziCol>
</IziGrid>